import React from 'react';
import { LogOut } from 'lucide-react';

// Название сервиса — из Настроек (service_name). Первое слово выделяется акцентом.
export function serviceName(settings) {
  return (settings?.service_name || '').trim() || 'VPN Support';
}

export default function Header({ settings, telegramUser, onLogout }) {
  const [first, ...rest] = serviceName(settings).split(' ');
  return (
    <header className="header" data-testid="app-header">
      <div className="header-brand">
        <div>
          <h1><span className="brand-accent">{first}</span>{rest.length ? ` ${rest.join(' ')}` : ''}</h1>
        </div>

        {telegramUser && onLogout && (
          <button
            className="logout-btn"
            onClick={onLogout}
            title="Выйти"
          >
            <LogOut size={17} />
          </button>
        )}
      </div>
    </header>
  );
}
